class ImagePopup extends ModalDialog {
  constructor() {
    super();
    this.cookieName = `image-popup-seen-${this.id}`;
  }

  connectedCallback() {
    this.delay = (parseFloat(this.dataset.delay) || 0) * 1000;
    this.cookieDays = parseInt(this.dataset.cookieDays, 10) || 7;

    if (window.Shopify && Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") {
        this.show();
      }
      return;
    }

    if (getCookie(this.cookieName) === "true") return;

    this.timer = setTimeout(() => {
      this.show();
      // Mark as seen so it won't show again for the configured number of days.
      setCookie(this.cookieName, "true", this.cookieDays);
    }, this.delay);
  }

  disconnectedCallback() {
    if (this.timer) clearTimeout(this.timer);
  }

  hide() {
    super.hide();
    setCookie(this.cookieName, "true", this.cookieDays);
  }
}

customElements.define("image-popup", ImagePopup);
